import { render, staticRenderFns } from "./EventView.vue?vue&type=template&id=90014a3c&scoped=true&"
import script from "./EventView.vue?vue&type=script&lang=js&"
export * from "./EventView.vue?vue&type=script&lang=js&"
import style0 from "./EventView.vue?vue&type=style&index=0&id=90014a3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90014a3c",
  null
  
)

export default component.exports